// For Get Client-Email-Events
export const GET_CLIENT_EMAIL_EVENTS = "GET_CLIENT_EMAIL_EVENTS"
export const GET_CLIENT_EMAIL_EVENTS_SUCCESS = "GET_CLIENT_EMAIL_EVENTS_SUCCESS"
export const GET_CLIENT_EMAIL_EVENTS_ERROR = "GET_CLIENT_EMAIL_EVENTS_ERROR"

// For Client-Email-Events
export const GET_CLIENT_EMAIL_TEMPLATE_BY_ID = "GET_CLIENT_EMAIL_TEMPLATE_BY_ID"
export const GET_CLIENT_EMAIL_TEMPLATE_BY_ID_SUCCESS = "GET_CLIENT_EMAIL_TEMPLATE_BY_ID_SUCCESS"
export const GET_CLIENT_EMAIL_TEMPLATE_BY_ID_ERROR = "GET_CLIENT_EMAIL_TEMPLATE_BY_ID_ERROR"

// FOR SENDGRID EMAIL STATUS
export const CHECK_CLIENT_EMAIL_STATUS_BY_EVENT = "CHECK_CLIENT_EMAIL_STATUS_BY_EVENT"
export const CHECK_CLIENT_EMAIL_STATUS_BY_EVENT_SUCCESS = "CHECK_CLIENT_EMAIL_STATUS_BY_EVENT_SUCCESS"
export const CHECK_CLIENT_EMAIL_STATUS_BY_EVENT_ERROR = "CHECK_CLIENT_EMAIL_STATUS_BY_EVENT_ERROR"

// FOR DELETE SENDGRID EMAIL STATUS
export const DELETE_CLIENT_EMAIL_STATUS_BY_EVENT = "DELETE_CLIENT_EMAIL_STATUS_BY_EVENT"
export const DELETE_CLIENT_EMAIL_STATUS_BY_EVENT_SUCCESS = "DELETE_CLIENT_EMAIL_STATUS_BY_EVENT_SUCCESS"
export const DELETE_CLIENT_EMAIL_STATUS_BY_EVENT_ERROR = "DELETE_CLIENT_EMAIL_STATUS_BY_EVENT_ERROR"

// FOR RESET EMAIL LOGS
export const RESET_CLIENT_EMAIL_TEMPLATE_BY_ID = "RESET_CLIENT_EMAIL_TEMPLATE_BY_ID"